import React, { useState } from 'react';
import PublicationCard from '../components/PublicationCard';
import NewDynamicBackground from '../components/NewDynamicBackground'; // import background
import './Publications.css';
import { publicationsData, topics, HCI } from '../data/publicationsData';

function Publications() {
  const [selectedTopic, setSelectedTopic] = useState('All');
  const [selectedHCI, setSelectedHCI] = useState('All');

  // Filter by topic and HCI
  const filteredPublications = publicationsData.filter(pub => {
    const topicMatch = selectedTopic === 'All' || pub.topic === selectedTopic;
    const hciMatch = selectedHCI === 'All' || pub.HCI === selectedHCI;
    return topicMatch && hciMatch;
  });

  // Sort by date (newest first)
  const sortedPublications = filteredPublications
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <>
        <NewDynamicBackground variant={4}/>

      <div className="content-wrapper">

        <div className="publications-intro">
          <p>
            My work is grounded in HCI, and mostly positioned at the intersection of HCI, Design and Health. 
            I publish across HCI venues, including ACM <em>CHI</em>, <em>UbiComp</em>, <em>DIS</em> and <em>TEI</em>, 
            as well as journals such as the <em>IJHCS</em>, <em>JHCI</em>, <em>BIT</em>, and <em>IwC</em>. 
            My work also appears in biomedical and clinical journals, such as the <em>J. Neuroeng. Rehabil</em>, <em>Biomed. Eng. Online</em>; 
            and in design and art venues and journals, such as <em>Leonardo</em> and <em>IASDR</em>.
          </p>
        </div>

        {/* Research Topics Filter */}
        <div className="filter-area">
        <div className="filter-row-1">
          <span className="filter-label">HCI × Health:</span>
          {topics.map((topic, index) => (
            <React.Fragment key={topic}>
              <button
                className={`filter-button ${selectedTopic === topic ? 'active' : ''}`}
                onClick={() => setSelectedTopic(topic)}
              >
                {topic}
              </button>
              {index < topics.length - 1 && <span className="separator">|</span>}
            </React.Fragment>
          ))}
        </div>

        {/* HCI Designs Filter */}
        <div className="filter-row-2">
          <span className="filter-label">HCI × Design:</span>
          {HCI.map((hci, index) => (
            <React.Fragment key={hci}>
              <button
                className={`filter-button ${selectedHCI === hci ? 'active' : ''}`}
                onClick={() => setSelectedHCI(hci)}
              >
                {hci}
              </button>
              {index < HCI.length - 1 && <span className="separator">|</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
        {/* Horizontal line below filters */}
        <div className="filters-separator"></div>

        {/* Publications list */}
        <div className="publications-list">
          {sortedPublications.map(pub => (
            <PublicationCard key={pub.id} publication={pub} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Publications;
